import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
  NgForm
} from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";

import { environment } from "../../../../environments/environment";
import { CrudService } from "../../../crud/crud.service";
import { NotificationsService } from 'angular2-notifications';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Mensaje } from "../../../mensaje";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from 'moment';

import { materialize } from 'rxjs/operators';
import { NumeroLetraPipe } from '../../../pipes/numero-letra.pipe';
import { Observable } from "rxjs";

@Component({
  selector: 'app-monitor-reprobados',
  templateUrl: './monitor-reprobados.component.html',
  styles: [
  ]
})
export class MonitorReprobadosComponent implements OnInit {

  dato = [];

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  API_PATH = environment.API_PATH;


  documentos = [];

  grupo_sel;
  tipo_boleta = 1;
  grupo;
  periodo_sel;
  cargando = false;
  
  logo_sucursal = "";
  logo_empresa = "";
  logo_carrera = "";

  activos = false;

  tipo_nivel = 0;
  mensajeResponse: Mensaje = new Mensaje(true);

  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private crudService: CrudService,
    private notificacion: NotificationsService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {


    document.getElementById("catalogos").click();
    
  }

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }
  }

  seleccionarPeriodo(event) {
    if (event) {
      if (event.hasOwnProperty("value")) {
        this.periodo_sel = event.value;
      } else {
        this.periodo_sel = event;
      }
    }
    this.grupo = null;
    this.grupo_sel = null;
  }

}
